export default __webpack_public_path__ + "static/media/github.8bce9409.svg";